<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: "App",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="less" scope></style>
